export default __webpack_public_path__ + "static/media/fpah0030.f748999a.png";